module.exports = __webpack_public_path__ + "static/swoop-5288019b1fa503245495ba83f3b3728e.png";